import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import InterviewerPersonalInfoComponent from "../../components/interviewer/profile/InterviewerPersonalInfoComponent";
import MasterDataService from '../../services/master-data-service';
import InterviewerService from '../../services/interviewer/interviewer-service';
import toasterUtils from "../../utils/toaster-utils";
import IdNameModel from "../../models/common/IdNameModel";
import InterviewerPersonalInfoModel from "../../models/interviewer/response/InterviewerPersonalInfoModel";
import modalUtils from "../../utils/modal-utils";
import { useHistory } from "react-router";

const InterviewerPersonalInfoModelDefault = {
    interviewerId: "",
    countryId: 0,
    cityId: 0,
    experienceId: 0,
    mobileNumber: 0,
    address: "",
    resumeTitle: "",
};

const InterviewerPersonalInfo = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [city, setCity] = useState<IdNameModel[]>([]);
    const [experience, setExperience] = useState<IdNameModel[]>([]);
    const [interviewerProfile, setInterviewerProfile] = useState<InterviewerPersonalInfoModel>(InterviewerPersonalInfoModelDefault);
    const [refreshInterviewerProfile, setRefreshInterviewerProfile] = useState<number>(2);

    useEffect(() => {
        if (loggedInUser) {
            getInterviewerProfile(loggedInUser.profileId);
        }
        getExperience();
    }, []);

    const getExperience = () => {
        MasterDataService.loadExperiences().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setExperience(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);

        });
    };

    const getInterviewerProfile = (interviewerId?: string) => {
        if (interviewerId) {
            modalUtils.showLoader();
            InterviewerService.getInterviewerPersonalInfo(interviewerId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setInterviewerProfile(res.data);
                getCity(res.data.countryId);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const getCity = (targetValue: number) => {
        modalUtils.showLoader();
        MasterDataService.loadCities(targetValue).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCity(res.items);
            setRefreshInterviewerProfile(refreshInterviewerProfile * 5);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Personal Info
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> MY Personal Info</h4>
            </div>
            <InterviewerPersonalInfoComponent
                key={refreshInterviewerProfile}
                objInterviewerProfile={interviewerProfile}
                experienceList={experience}
                cityList={city} />
        </Layout>
    );
};
export default InterviewerPersonalInfo;